import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Divider, Paper, Typography } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { NoData2 } from 'components'
import InventoryItemCard from '../InventoryItemCard'

import useStyles from './styles'

const InventoryPanel = ({
  items,
  activeItemId,
  showConclusion,
  onConclude,
  showRisk = true,
}) => {
  const classes = useStyles()
  const [expandedId, setExpandedId] = useState(null)

  // Itens presentes quando o painel monta (1ª IA cadastrada): a entrada deles é
  // coberta pela animação do próprio painel (panelEnter), então não animam um a
  // um. Só as IAs cadastradas DEPOIS, com o painel já visível, animam (cardEnter).
  const initialItemIdsRef = useRef(null)
  if (initialItemIdsRef.current === null) {
    initialItemIdsRef.current = new Set(items.map((item) => item.id))
  }

  // Abre o card da IA que o agente tocou por último na conversa (criou ou
  // editou). Só dispara quando o item ativo muda — preserva o toggle manual do
  // usuário entre turnos que não mexem em item nenhum.
  useEffect(() => {
    if (activeItemId != null) setExpandedId(activeItemId)
  }, [activeItemId])

  const handleToggle = (itemId) => (_, isExpanded) =>
    setExpandedId(isExpanded ? itemId : null)

  return (
    <Paper variant="outlined" className={classes.panel}>
      <Box className={classes.header}>
        <Typography variant="h5" className={classes.title}>
          Listagem de cadastro de IAs
        </Typography>
      </Box>

      <Divider />

      <Box className={classes.list}>
        {isEmpty(items) ? (
          <NoData2
            withoutPaper
            title="Nenhuma IA cadastrada ainda"
            subTitle="Converse com a DAI para começar."
          />
        ) : (
          items.map((item) => (
            <InventoryItemCard
              key={item.id}
              item={item}
              expanded={expandedId === item.id}
              onChange={handleToggle(item.id)}
              animateOnEnter={!initialItemIdsRef.current.has(item.id)}
              showRisk={showRisk}
            />
          ))
        )}
      </Box>

      <Divider />

      <Box className={classes.footer}>
        <Button
          variant="contained"
          color="primary"
          onClick={onConclude}
          disabled={!showConclusion}
        >
          Revisar
        </Button>
      </Box>
    </Paper>
  )
}

InventoryPanel.propTypes = {
  items: PropTypes.array,
  activeItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showConclusion: PropTypes.bool,
  onConclude: PropTypes.func,
  showRisk: PropTypes.bool,
}

export default InventoryPanel
